(function(w,d,$){
  'use strict';
  if (!$) return;

  var script = d.currentScript;
  var imageBalance = !script || script.getAttribute('data-image-balance') !== 'false';
  var titleBalance = !script || script.getAttribute('data-title-balance') !== 'false';
  var imageWidth = parseInt(script && script.getAttribute('data-image-width'), 10) || 290;
  var imageHeight = parseInt(script && script.getAttribute('data-image-height'), 10) || 290;
  var A = w.AT_Main = w.AT_Main || {};
  var resizeQueued = false;

  A.getWidthBrowser = function(){
    return w.innerWidth || (d.documentElement && d.documentElement.clientWidth) || (d.body && d.body.clientWidth) || 0;
  };

  A.checkLayout = function(){
    if ($('#checkLayout .visible-xs-block').css('display') === 'block') return 1;
    if ($('#checkLayout .visible-sm-block').css('display') === 'block') return 2;
    if ($('#checkLayout .visible-md-block').css('display') === 'block') return 3;
    if ($('#checkLayout .visible-lg-block').css('display') === 'block') return 4;
  };

  A.fixNoScroll = function(){
    var width = $(w).width();
    $('#page-body, .header-content, #page-body .mobile-version').css('width', width + 'px');
  };

  A.fixReturnScroll = function(){
    $('#page-body, .header-content, #page-body .mobile-version').attr('style', '');
  };

  A.toTopButton = function(){
    var button = $('#scroll-to-top');
    if (!button.length) return;
    var ticking = false;
    function update(){
      var top = w.pageYOffset || d.documentElement.scrollTop || 0;
      var height = w.innerHeight || d.documentElement.clientHeight || 0;
      var marker = top > 100 ? top + height / 2 : 1;
      button.removeClass('on off').addClass(marker < 1000 && marker < height ? 'off' : 'on');
    }
    function onScroll(){
      if (ticking) return;
      ticking = true;
      (w.requestAnimationFrame || function(cb){ return w.setTimeout(cb,16); })(function(){ update(); ticking = false; });
    }
    w.addEventListener('scroll', onScroll, { passive: true });
    update();
    button.off('click.iceCollection').on('click.iceCollection', function(e){
      e.preventDefault();
      $('body,html').animate({scrollTop:0},800,'swing');
    });
  };

  A.effectNavigation = function(){
    $('.horizontal-menu .navigation .navbar-collapse .main-nav>li').off('.iceCollectionNav').on('mouseenter.iceCollectionNav', function(){
      $(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').addClass('fadeInUp animated');
    }).on('mouseleave.iceCollectionNav', function(){
      $(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').removeClass('fadeInUp animated');
    });
    $('.verticle-menu .navigation .navbar-collapse .main-nav>li').off('.iceCollectionNav').on('mouseenter.iceCollectionNav', function(){
      $(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').addClass('fadeInRight animated');
    }).on('mouseleave.iceCollectionNav', function(){
      $(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').removeClass('fadeInRight animated');
    });
    $('.cart-target').off('.iceCollectionNav').on('mouseenter.iceCollectionNav', function(){
      $(this).find('>.dropdown-menu').addClass('fadeInUp animated');
    }).on('mouseleave.iceCollectionNav', function(){
      $(this).find('>.dropdown-menu').removeClass('fadeInUp animated');
    });
  };

  A.fixButton = function(){
    $('.product-wrapper .product-head').each(function(){
      if ($(this).children().hasClass('wrapper-countdown')) $(this).find('.product-button').addClass('fix');
    });
    $('.shipping-title').off('click.iceCollection').on('click.iceCollection', function(){ $('.shipping').toggle(); });
  };

  A.handleReviews = function(){
    if (!w.SPR) return;
    try {
      if (typeof w.SPR.registerCallbacks === 'function') w.SPR.registerCallbacks();
      if (typeof w.SPR.initRatingHandler === 'function') w.SPR.initRatingHandler();
      if (typeof w.SPR.initDomEls === 'function') w.SPR.initDomEls();
      if (typeof w.SPR.loadProducts === 'function') w.SPR.loadProducts();
      if (typeof w.SPR.loadBadges === 'function') w.SPR.loadBadges();
    } catch (e) {}
  };

  A.menuOnMobile = function(){
    $('#page-body').off('click.iceCollectionMenu').on('click.iceCollectionMenu', function(){
      $('.menu-mobile').removeClass('opened');
      $('html,body').removeClass('menu-opened');
      A.fixReturnScroll();
    });
    $(d).off('click.iceCollectionMenu','[data-toggle=offcanvas]').on('click.iceCollectionMenu','[data-toggle=offcanvas]',function(e){
      e.stopPropagation();
      A.fixNoScroll();
      $('.menu-mobile').toggleClass('opened');
      $('html,body').toggleClass('menu-opened');
    });
    $('.navbar .main-nav li').off('.iceCollectionHover').on('mouseenter.iceCollectionHover', function(){ $(this).addClass('hover'); }).on('mouseleave.iceCollectionHover', function(){ $(this).removeClass('hover'); });
    $(d).off('click.iceCollectionMenu','.mobile-version .menu-mobile .main-nav .expand').on('click.iceCollectionMenu','.mobile-version .menu-mobile .main-nav .expand',function(){
      var parent = $(this).parents('.dropdown').first();
      if (parent.hasClass('menu-mobile-open')) {
        parent.removeClass('menu-mobile-open');
        $(this).find('.visible-xs').removeClass('fa-minus').addClass('fa-plus');
      } else {
        parent.addClass('menu-mobile-open');
        $(this).find('.visible-xs').removeClass('fa-plus').addClass('fa-minus');
      }
    });
  };

  A.handleMenuMultiLine = function(){
    var outItem = '', down = false;
    $('.navbar-collapse .main-nav > li').off('.iceCollectionMulti').on('mousemove.iceCollectionMulti', function(e){
      var target = $(e.currentTarget);
      if (down && outItem !== '') {
        outItem.addClass('hold');
        w.setTimeout(function(){
          if (outItem !== '') outItem.removeClass('hold');
          down = false;
          outItem = '';
        },500);
        if (outItem[0] === target[0] || outItem.offset().top === target.offset().top) {
          outItem.removeClass('hold');
          down = false;
          outItem = '';
        }
      } else {
        outItem = '';
      }
    }).on('mouseout.iceCollectionMulti', function(e){
      var target = $(e.currentTarget);
      if (e.pageY >= target.offset().top + 50) down = true;
      if (target.hasClass('dropdown') && outItem === '') outItem = target;
    });
  };

  A.toggleFilterSidebar = function(){
    var $filter = $('[data-ice-native-filters]');
    var $toggle = $('.filter-toggle[aria-controls="IceNativeFilters"]');
    var isMobileFilter = function(){
      return w.matchMedia ? w.matchMedia('(max-width: 767px)').matches : $(w).width() < 768;
    };
    var setFilterAccessibility = function(isOpen){
      if (!$filter.length) return;
      if (isMobileFilter()) {
        $filter.attr('aria-hidden', isOpen ? 'false' : 'true');
        if (isOpen) $filter.removeAttr('inert');
        else $filter.attr('inert','');
      } else {
        $filter.removeAttr('aria-hidden').removeAttr('inert');
      }
      $toggle.attr('aria-expanded', isOpen ? 'true' : 'false');
    };
    setFilterAccessibility($filter.hasClass('opened'));
    $(w).off('resize.iceCollectionFilterA11y').on('resize.iceCollectionFilterA11y', function(){
      if (!isMobileFilter()) {
        $filter.removeClass('opened');
        $('html,body').removeClass('filter-opened');
        $toggle.attr('aria-expanded','false');
        if (w.AT_Main && typeof w.AT_Main.fixReturnScroll === 'function') w.AT_Main.fixReturnScroll();
      }
      setFilterAccessibility($filter.hasClass('opened'));
    });
    $(d).off('click.iceCollectionFilter','.filter-toggle').on('click.iceCollectionFilter','.filter-toggle', function(e){
      e.stopPropagation();
      A.fixNoScroll();
      var isOpen = !$filter.hasClass('opened');
      $filter.toggleClass('opened', isOpen);
      $('html,body').toggleClass('filter-opened', isOpen);
      setFilterAccessibility(isOpen);
      if (isOpen) $filter.find('[data-ice-filter-close]').trigger('focus');
    });
    $(d).off('click.iceCollectionFilter','#page-body').on('click.iceCollectionFilter','#page-body', function(){
      $filter.removeClass('opened');
      $('html,body').removeClass('filter-opened');
      setFilterAccessibility(false);
    });
  };

  A.callPriceSlider = function(){
    if (w.ICEPriceSlider && typeof w.ICEPriceSlider.init === 'function') w.ICEPriceSlider.init();
  };

  A.dropdownFilter = function(){
    $(d).off('click.iceCollectionDropdown','.sb-filter .sbf-title>span').on('click.iceCollectionDropdown','.sb-filter .sbf-title>span',function(e){
      e.stopPropagation();
      $(this).toggleClass('none-active');
      $(this).closest('.sb-filter').find('.advanced-filters').toggleClass('hide');
    });
  };

  A.fixTitle = function(){
    $('.rt a').each(function(){
      var link = $(this);
      if (link.attr('title')) link.attr('data-title', link.attr('title')).removeAttr('title');
    });
  };

  function buildClearFilterUrl(filterId){
    var url = w.location.href;
    var hash = '';
    var hashPos = url.indexOf('#');
    if (hashPos !== -1) { hash = url.slice(hashPos); url = url.slice(0, hashPos); }
    var query = '';
    var queryPos = url.indexOf('?');
    if (queryPos !== -1) { query = url.slice(queryPos); url = url.slice(0, queryPos); }
    var parts = url.split('/');
    var tail = parts.pop() || '';
    var active = [];
    $('#' + filterId + ' li.active-filter').each(function(){
      var handle = $(this).attr('data-handle');
      if (handle) active.push(handle);
    });
    var remaining = tail.split('+').filter(function(item){ return item && active.indexOf(item) === -1; });
    parts.push(remaining.join('+'));
    return parts.join('/').replace(/\/$/, remaining.length ? '' : '/') + query + hash;
  }

  A.filterCatalogReplace = function(){ return w.location.href; };

  A.filterCatalog = function(){
    $('.advanced-filter').each(function(){
      var el = $(this);
      if (el.hasClass('active-filter')) el.parents('.sb-filter').find('a.clear-filter').removeClass('hidden');
    });
    $('.sb-filter').off('click.iceCollectionClear','.clear-filter').on('click.iceCollectionClear','.clear-filter',function(e){
      e.preventDefault();
      var filterId = ($(this).attr('id') || '').replace('clear-', '');
      if (!filterId) return;
      w.location.href = buildClearFilterUrl(filterId);
    });
  };

  A.cartJS_handle = function(){
    $(d).off('cart.requestComplete.iceCollection').on('cart.requestComplete.iceCollection', function(event, cart){
      if (w.Shopify && typeof w.Shopify.onCartUpdate === 'function') {
        w.Shopify.onCartUpdate(cart || (w.CartJS && w.CartJS.cart) || {});
      }
    });
  };

  function ensureBalanceStyle(){
    var id = 'ice-collection-image-balance-style';
    var style = d.getElementById(id);
    if (!style) {
      style = d.createElement('style');
      style.id = id;
      d.head.appendChild(style);
    }
    style.textContent = '@media (min-width:768px){' +
      'html body.templateCollection .cata-product.cp-grid.ice-image-balance .featured-img>a{' +
      'display:block;position:relative;overflow:hidden;width:' + imageWidth + 'px;height:' + imageHeight + 'px;}' +
      'html body.templateCollection .cata-product.cp-grid.ice-image-balance img.featured-image.front,' +
      'html body.templateCollection .cata-product.cp-grid.ice-image-balance img.rotate-product-image{' +
      'width:100%!important;height:100%!important;max-width:none!important;object-fit:cover!important;object-position:center!important;}' +
      '}';
  }

  A.scareImage = function(){
    var grid = $('.cata-product.cp-grid');
    if (!grid.length) return;
    if (!imageBalance) { grid.removeClass('ice-image-balance'); return; }
    ensureBalanceStyle();
    grid.addClass('ice-image-balance');
  };

  A.scareName = function(){
    var names = $('.cata-product.cp-grid h5.product-name');
    if (!names.length) return;
    names.css('height','');
    if (!titleBalance || A.getWidthBrowser() < 768) return;
    var max = 0;
    names.each(function(){ max = Math.max(max, $(this).outerHeight()); });
    if (max > 0) names.css('height', max + 'px');
  };

  A.scareScreen = function(){
    A.scareImage();
    A.scareName();
    $(d).off('ajaxComplete.iceCollectionBalance').on('ajaxComplete.iceCollectionBalance', function(){
      A.scareImage();
      A.scareName();
    });
  };

  A.init = function(){
    A.toTopButton();
    A.effectNavigation();
    A.fixButton();
    A.menuOnMobile();
    A.handleMenuMultiLine();
    A.toggleFilterSidebar();
    A.callPriceSlider();
    A.dropdownFilter();
    A.fixTitle();
    A.filterCatalog();
    A.cartJS_handle();
    A.scareScreen();
  };

  w.addEventListener('resize', function(){
    if (resizeQueued) return;
    resizeQueued = true;
    (w.requestAnimationFrame || function(cb){ return w.setTimeout(cb,16); })(function(){
      resizeQueued = false;
      if (A.getWidthBrowser() < 1024 && $('#top').hasClass('on')) {
        $('#top').prev().remove();
        $('#top').removeClass('on animated');
      }
      A.fixReturnScroll();
      if (A.checkLayout() !== 1 && $('.menu-mobile').hasClass('opened')) $('#page-body').trigger('click');
      A.scareImage();
      A.scareName();
    });
  }, { passive: true });

  $(function(){
    A.init();
  });
}(window,document,window.jQuery));
